import { useEffect, useState } from "react";
import { useCart } from "../../context/Cart/CartContext";
import PayMethods from "../../components/PayMethods/PayMethods";
import { api } from "../../services/api";

function PayMethodsContainer() {
	const [paymentForm, setPaymentForm] = useState({ paymentMethod: "efectivo" });
	const [banks, setBanks] = useState();
	const [expanded, setExpanded] = useState(false);
	const { cart } = useCart();

	const handleExpandClick = () => {
		setExpanded(!expanded);
	};

	const handleRadio = (evt) => {
		setPaymentForm({ paymentMethod: evt.target.value });
	};

	useEffect(() => {
		api.checkout
			.getBanks()
			.then((res) => res.json())
			.catch((err) => console.log(err))
			.then(setBanks)
			.catch((err) => console.log(err));
	}, []);

	return (
		<PayMethods
			productsInCart={cart?.length}
			banks={banks}
			expanded={expanded}
			handleExpandClick={handleExpandClick}
			paymentForm={paymentForm}
			handleRadio={handleRadio}
		/>
	);
}

export default PayMethodsContainer;
